import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import LinkIcon from '../../images/icon_link.svg';
import SectionTitle from './common/SectionTitle';
import { Query, WpPost } from '../../types/gatsby-graphql';

interface IndexPageProps {
  item: WpPost;
}

const NewsItem: React.VFC<IndexPageProps> = ({ item }) => (
  <div>
    <dl className="py-6 md:flex md:items-start">
      <div className="flex items-center md:mt-1">
        <dt className="sr-only">投稿日</dt>
        <dd className="w-20 text-sm">{item.date.substring(0, 10)}</dd>
        <dt className="sr-only">カテゴリー</dt>
        {item.categories?.nodes && item.categories.nodes[0] && (
          <dd
            key={item.categories.nodes[0].link}
            className="px-5 text-xs text-primary"
          >
            {item.categories.nodes[0].name}
          </dd>
        )}
      </div>
      <div className="mt-2 md:mt-0 md:flex-1">
        <dt className="sr-only">タイトル</dt>
        <dd className="break-all leading-loose">
          <a
            href={`https://lisatech.jp/news/${item.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="duration-300 hover:opacity-60"
          >
            {item.title}
          </a>
        </dd>
      </div>
    </dl>
  </div>
);

const News = () => {
  const data: Query = useStaticQuery(graphql`
    query PostsQuery {
      allWpPost(
        filter: {
          categories: { nodes: { elemMatch: { name: { eq: "FDMリリース" } } } }
        }
        sort: { fields: date, order: DESC }
        limit: 3
      ) {
        edges {
          node {
            id
            title
            date
            categories {
              nodes {
                name
                link
              }
            }
          }
        }
      }
    }
  `);
  return (
    <section className="border-t md:border-none border-gray-lightest" id="news">
      <div className="container py-15 md:py-20 md:border-t border-gray-lightest">
        <SectionTitle>お知らせ</SectionTitle>
        <ul className="mt-5 mx-auto max-w-2xl">
          {data.allWpPost.edges.map(({ node }, index) => (
            <li key={node.id} className={index !== 0 ? 'border-t' : ''}>
              <NewsItem item={node} />
            </li>
          ))}
        </ul>
        <div className="mt-10 md:mt-15 text-center">
          <a
            href="https://lisatech.jp/news"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-gray-lightest rounded-full inline-flex items-center justify-center w-40 text-sm px-4 py-2 duration-300 hover:opacity-60"
          >
            <span className="mr-2">一覧をみる</span>
            <LinkIcon />
          </a>
        </div>
      </div>
    </section>
  );
};

export default News;
